import React, { useEffect, useState  } from 'react';
import { TimepickerUI } from "timepicker-ui";
import swal from 'sweetalert2';
import { deleteCalendar, getCalendar, postCalendar } from './api/calendarAPI';

const Calendar = () => {

    const [calendar,             setCalendar]             = useState([]);
    const [calendarId,           setCalendarId]           = useState(0);
    const [mondayValidated,      setMondayValidated]      = useState(false);
    const [tuesdayValidated,     setTuesdayValidated]     = useState(false);
    const [wednesdayValidated,   setWednesdayValidated]   = useState(false);
    const [thursdayValidated,    setThursdayValidated]    = useState(false);
    const [fridayValidated,      setFridayValidated]      = useState(false);
    const [saturdayValidated,    setSaturdayValidated]    = useState(false);
    const [sundayValidated,      setSundayValidated]      = useState(false);
     

    useEffect(() => {
        fetchCalendar();

        const DOMElements = document.querySelectorAll(".timepicker-ui");
        const options = {editable: true};

        DOMElements.forEach((element) => {
            const newTimepicker = new TimepickerUI(element, options);
            newTimepicker.create();
        });
    }, []);

    const fetchCalendar = async() => {
        try {
            swal.fire({
                titleText           : 'Loading',
                text                : 'Please Wait...',
                showConfirmButton   : false,
                allowOutsideClick   : false,
                didOpen: () => {
                    swal.showLoading();
                }
            });
            const { Calendar } = await getCalendar();
            setCalendar(Calendar);
            swal.close();
        } catch (err) {
            swal.close();
            swal.fire({ icon: "error", titleText: "Error!", text: err.message });
            return;  
        }
    }

    const postCalendarData = async(e, day) => {
        e.preventDefault();
        const form = e.currentTarget;
        if (form.checkValidity() === false) {     
            e.stopPropagation();
            setValidated(day, true);
        }else{
            try {
                swal.fire({
                    titleText           : 'Loading',
                    text                : 'Please Wait...',
                    showConfirmButton   : false,
                    allowOutsideClick   : false,
                    didOpen: () => {
                        swal.showLoading();
                    }
                });
    
                const from = document.getElementById(`txtFrom${day}`).value;
                const to = document.getElementById(`txtTo${day}`).value;
    
                await postCalendar({
                    ID      : calendarId,
                    Day     : day,
                    From    : from,
                    To      : to
                })
                fetchCalendar();
                resetData(day);
                swal.close();
            } catch (err) {
                swal.close();
                swal.fire({ icon: "error", titleText: "Error!", text: err.message });
                return;  
            }
        }
        
    }

    const deleteCalendarData = async (id) => {
        try {
            await deleteCalendar(id);
            fetchCalendar();
        } catch (err) {
            swal.fire({ icon: "error", titleText: "Error!", text: err.message });
            return;  
        }
    }

    const updateActive = async (c, active) => {
        try {
            await postCalendar({...c, Active: active});
            fetchCalendar();
        } catch (err) {
            swal.fire({ icon: "error", titleText: "Error!", text: err.message });
            return;  
        }
    }

    const updateCalendar = (c) => {
        document.getElementById(`txtFrom${c.Day}`).value = c.From;
        document.getElementById(`txtTo${c.Day}`).value = c.To;
        setCalendarId(c.ID);
    }

    const resetData = (day) => {
        document.getElementById(`txtFrom${day}`).value = '';
        document.getElementById(`txtTo${day}`).value = '';
        setValidated(day, false);
        setCalendarId(0);
    }

    const setValidated = (day, value) => {
        day == 'Monday' &&  setMondayValidated(value);
        day == 'Tuesday' &&  setTuesdayValidated(value);
        day == 'Wednesday' &&  setWednesdayValidated(value);
        day == 'Thursday' &&  setThursdayValidated(value);
        day == 'Friday' &&  setFridayValidated(value);
        day == 'Saturday' &&  setSaturdayValidated(value);
        day == 'Sunday' &&  setSundayValidated(value);
    }


    return ( 
        <>
            <div className='container margin-t100'>  
                <div className='row'>
                    <div className='col-12'> 
                        <div className="accordion" id="accordionCalendar">
                            <div className="accordion-item">
                                <h2 className="accordion-header" id="headingMonday"> 
                                    <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseMonday" aria-expanded="false" aria-controls="collapseMonday" onClick={() => resetData('Monday')}>
                                        Monday
                                    </button>
                                </h2>
                                <div id="collapseMonday" className="accordion-collapse collapse" aria-labelledby="headingMonday" data-bs-parent="#accordionCalendar">
                                    <div className="accordion-body">
                                        <form id='mondayFrom' className={`row mt-4 needs-validation ${mondayValidated ? "was-validated" : ""}`} noValidate onSubmit={(event) => postCalendarData(event, 'Monday')}>
                                            <div className='col-md-5'>
                                                <div className='input-group mb-3 timepicker-ui'>
                                                    <span className='input-group-text fs-16'>From</span>
                                                    <input
                                                        id='txtFromMonday'
                                                        type='text'
                                                        placeholder="Select time"
                                                        className='form-control fs-16 timepicker-ui-input'
                                                        required
                                                    />
                                                    <span className='input-group-text fs-16'><i className="bi bi-clock"></i></span>
                                                    <div className="invalid-feedback">Please select time.</div>
                                                </div>
                                            </div>
                                            <div className='col-md-5'>
                                                <div className='input-group mb-3 timepicker-ui'>
                                                    <span className='input-group-text fs-16'>To</span>
                                                    <input
                                                        id='txtToMonday'
                                                        type='text'
                                                        placeholder="Select time"
                                                        className='form-control fs-16 timepicker-ui-input'
                                                        required
                                                    />
                                                    <span className='input-group-text fs-16'><i className="bi bi-clock"></i></span>
                                                    <div className="invalid-feedback">Please select time.</div>
                                                </div>
                                            </div>
                                            <div className='col-md-2'>
                                                {calendarId != 0 ? (
                                                    <button type="submit" form='mondayFrom' className="btn btn-success btn-header w-100 mb-3">
                                                        Update
                                                    </button>
                                                ) : (
                                                    <button type="submit" form='mondayFrom' className="btn btn-primary btn-header w-100 mb-3">
                                                        <i className="bi bi-plus-lg me-2"></i>Add
                                                    </button>
                                                )}
                                            </div>
                                        </form>

                                        <div className='row mt-3 mb-4'>
                                            <div className='col-12'>
                                                <ul className="list-group">
                                                    {calendar.filter(f => f.Day == 'Monday').length > 0 && calendar.filter(f => f.Day == 'Monday').map((m, i) => (
                                                        <li key={m.ID} className="list-group-item d-flex justify-content-between align-items-center">
                                                            {m.From} - {m.To}
                                                            <div className='d-flex align-items-center'>
                                                                <button onClick={() => updateCalendar(m)} type="button" className="btn btn-outline-primary btn-sm me-2">
                                                                    <i className="bi bi-pencil"></i>
                                                                </button>
                                                                <button onClick={() => deleteCalendarData(m.ID)} type="button" className="btn btn-outline-danger btn-sm me-2">
                                                                    <i className="bi bi-trash"></i>
                                                                </button>
                                                                <div className="form-check form-switch">
                                                                    <input 
                                                                        className="form-check-input switch" 
                                                                        type="checkbox" 
                                                                        defaultChecked={m.Active == 'N' ? '' : 'checked'} 
                                                                        onChange={(event) => updateActive(m, event.target.checked ? 'Y' : 'N')} 
                                                                    />
                                                                </div>
                                                            </div>
                                                        </li>
                                                    ))}                                   
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="accordion-item">
                                <h2 className="accordion-header" id="headingTuesday"> 
                                    <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseTuesday" aria-expanded="false" aria-controls="collapseTuesday" onClick={() => resetData('Tuesday')}>
                                        Tuesday
                                    </button>
                                </h2>
                                <div id="collapseTuesday" className="accordion-collapse collapse" aria-labelledby="headingTuesday" data-bs-parent="#accordionCalendar">
                                    <div className="accordion-body">
                                        <form id='tuesdayFrom' className={`row mt-4 needs-validation ${tuesdayValidated ? "was-validated" : ""}`} noValidate onSubmit={(event) => postCalendarData(event, 'Tuesday')}>
                                            <div className='col-md-5'>
                                                <div className='input-group mb-3 timepicker-ui'>
                                                    <span className='input-group-text fs-16'>From</span>
                                                    <input
                                                        id='txtFromTuesday'
                                                        type='text'
                                                        placeholder="Select time"
                                                        className='form-control fs-16 timepicker-ui-input'
                                                        required
                                                    />
                                                    <span className='input-group-text fs-16'><i className="bi bi-clock"></i></span>
                                                    <div className="invalid-feedback">Please select time.</div>
                                                </div>
                                            </div>
                                            <div className='col-md-5'>
                                                <div className='input-group mb-3 timepicker-ui'>
                                                    <span className='input-group-text fs-16'>To</span>
                                                    <input
                                                        id='txtToTuesday'
                                                        type='text'
                                                        placeholder="Select time"
                                                        className='form-control fs-16 timepicker-ui-input'
                                                        required
                                                    />
                                                    <span className='input-group-text fs-16'><i className="bi bi-clock"></i></span>
                                                    <div className="invalid-feedback">Please select time.</div>
                                                </div>
                                            </div>
                                            <div className='col-md-2'>
                                                {calendarId != 0 ? (
                                                    <button type="submit" form='tuesdayFrom' className="btn btn-success btn-header w-100 mb-3">
                                                        Update
                                                    </button>
                                                ) : (
                                                    <button type="submit" form='tuesdayFrom' className="btn btn-primary btn-header w-100 mb-3">
                                                        <i className="bi bi-plus-lg me-2"></i>Add
                                                    </button>
                                                )}
                                            </div>
                                        </form>

                                        <div className='row mt-3 mb-4'>
                                            <div className='col-12'>
                                                <ul className="list-group">
                                                    {calendar.filter(f => f.Day == 'Tuesday').length > 0 && calendar.filter(f => f.Day == 'Tuesday').map((m, i) => (
                                                        <li key={m.ID} className="list-group-item d-flex justify-content-between align-items-center">
                                                            {m.From} - {m.To}
                                                            <div className='d-flex align-items-center'>
                                                                <button onClick={() => updateCalendar(m)} type="button" className="btn btn-outline-primary btn-sm me-2">
                                                                    <i className="bi bi-pencil"></i>
                                                                </button>
                                                                <button onClick={() => deleteCalendarData(m.ID)} type="button" className="btn btn-outline-danger btn-sm me-2">
                                                                    <i className="bi bi-trash"></i>
                                                                </button>
                                                                <div className="form-check form-switch">
                                                                    <input 
                                                                        className="form-check-input switch" 
                                                                        type="checkbox" 
                                                                        defaultChecked={m.Active == 'N' ? '' : 'checked'} 
                                                                        onChange={(event) => updateActive(m, event.target.checked ? 'Y' : 'N')} 
                                                                    />
                                                                </div>
                                                            </div>
                                                        </li>
                                                    ))}                                   
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                           

                            <div className="accordion-item">
                                <h2 className="accordion-header" id="headingWednesday"> 
                                    <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseWednesday" aria-expanded="false" aria-controls="collapseWednesday" onClick={() => resetData('Wednesday')}>
                                        Wednesday
                                    </button>
                                </h2>
                                <div id="collapseWednesday" className="accordion-collapse collapse" aria-labelledby="headingWednesday" data-bs-parent="#accordionCalendar">
                                    <div className="accordion-body">
                                        <form id='wednesdayFrom' className={`row mt-4 needs-validation ${wednesdayValidated ? "was-validated" : ""}`} noValidate onSubmit={(event) => postCalendarData(event, 'Wednesday')}>
                                            <div className='col-md-5'>
                                                <div className='input-group mb-3 timepicker-ui'>
                                                    <span className='input-group-text fs-16'>From</span>
                                                    <input
                                                        id='txtFromWednesday'
                                                        type='text'
                                                        placeholder="Select time"
                                                        className='form-control fs-16 timepicker-ui-input'
                                                        required
                                                    />
                                                    <span className='input-group-text fs-16'><i className="bi bi-clock"></i></span>
                                                    <div className="invalid-feedback">Please select time.</div>
                                                </div>
                                            </div>
                                            <div className='col-md-5'>
                                                <div className='input-group mb-3 timepicker-ui'>
                                                    <span className='input-group-text fs-16'>To</span>
                                                    <input
                                                        id='txtToWednesday'
                                                        type='text'
                                                        placeholder="Select time"
                                                        className='form-control fs-16 timepicker-ui-input'
                                                        required
                                                    />
                                                    <span className='input-group-text fs-16'><i className="bi bi-clock"></i></span>
                                                    <div className="invalid-feedback">Please select time.</div>
                                                </div>
                                            </div>
                                            <div className='col-md-2'>
                                                {calendarId != 0 ? (
                                                    <button type="submit" form='wednesdayFrom' className="btn btn-success btn-header w-100 mb-3">
                                                        Update
                                                    </button>
                                                ) : (
                                                    <button type="submit" form='wednesdayFrom' className="btn btn-primary btn-header w-100 mb-3">
                                                        <i className="bi bi-plus-lg me-2"></i>Add
                                                    </button>
                                                )}
                                            </div>
                                        </form>

                                        <div className='row mt-3 mb-4'>
                                            <div className='col-12'>
                                                <ul className="list-group">
                                                    {calendar.filter(f => f.Day == 'Wednesday').length > 0 && calendar.filter(f => f.Day == 'Wednesday').map((m, i) => (
                                                        <li key={m.ID} className="list-group-item d-flex justify-content-between align-items-center">
                                                            {m.From} - {m.To}
                                                            <div className='d-flex align-items-center'>
                                                                <button onClick={() => updateCalendar(m)} type="button" className="btn btn-outline-primary btn-sm me-2">
                                                                    <i className="bi bi-pencil"></i>
                                                                </button>
                                                                <button onClick={() => deleteCalendarData(m.ID)} type="button" className="btn btn-outline-danger btn-sm me-2">
                                                                    <i className="bi bi-trash"></i>
                                                                </button>
                                                                <div className="form-check form-switch">
                                                                    <input 
                                                                        className="form-check-input switch" 
                                                                        type="checkbox" 
                                                                        defaultChecked={m.Active == 'N' ? '' : 'checked'} 
                                                                        onChange={(event) => updateActive(m, event.target.checked ? 'Y' : 'N')} 
                                                                    />
                                                                </div>
                                                            </div>
                                                        </li>
                                                    ))}                                   
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                           
                            <div className="accordion-item">
                                <h2 className="accordion-header" id="headingThursday"> 
                                    <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseThursday" aria-expanded="false" aria-controls="collapseThursday" onClick={() => resetData('Thursday')}>
                                        Thursday
                                    </button>
                                </h2>
                                <div id="collapseThursday" className="accordion-collapse collapse" aria-labelledby="headingThursday" data-bs-parent="#accordionCalendar">
                                    <div className="accordion-body">
                                        <form id='thursdayFrom' className={`row mt-4 needs-validation ${thursdayValidated ? "was-validated" : ""}`} noValidate onSubmit={(event) => postCalendarData(event, 'Thursday')}>
                                            <div className='col-md-5'>
                                                <div className='input-group mb-3 timepicker-ui'>
                                                    <span className='input-group-text fs-16'>From</span>
                                                    <input
                                                        id='txtFromThursday'
                                                        type='text'
                                                        placeholder="Select time"
                                                        className='form-control fs-16 timepicker-ui-input'
                                                        required
                                                    />
                                                    <span className='input-group-text fs-16'><i className="bi bi-clock"></i></span>
                                                    <div className="invalid-feedback">Please select time.</div>
                                                </div>
                                            </div>
                                            <div className='col-md-5'>
                                                <div className='input-group mb-3 timepicker-ui'>
                                                    <span className='input-group-text fs-16'>To</span>
                                                    <input
                                                        id='txtToThursday'
                                                        type='text'
                                                        placeholder="Select time"
                                                        className='form-control fs-16 timepicker-ui-input'
                                                        required
                                                    />
                                                    <span className='input-group-text fs-16'><i className="bi bi-clock"></i></span>
                                                    <div className="invalid-feedback">Please select time.</div>
                                                </div>
                                            </div>
                                            <div className='col-md-2'>
                                                {calendarId != 0 ? (
                                                    <button type="submit" form='thursdayFrom' className="btn btn-success btn-header w-100 mb-3">
                                                        Update
                                                    </button>
                                                ) : (
                                                    <button type="submit" form='thursdayFrom' className="btn btn-primary btn-header w-100 mb-3">
                                                        <i className="bi bi-plus-lg me-2"></i>Add
                                                    </button>
                                                )}
                                            </div>
                                        </form>

                                        <div className='row mt-3 mb-4'>
                                            <div className='col-12'>
                                                <ul className="list-group">
                                                    {calendar.filter(f => f.Day == 'Thursday').length > 0 && calendar.filter(f => f.Day == 'Thursday').map((m, i) => (
                                                        <li key={m.ID} className="list-group-item d-flex justify-content-between align-items-center">
                                                            {m.From} - {m.To}
                                                            <div className='d-flex align-items-center'>
                                                                <button onClick={() => updateCalendar(m)} type="button" className="btn btn-outline-primary btn-sm me-2">
                                                                    <i className="bi bi-pencil"></i>
                                                                </button>
                                                                <button onClick={() => deleteCalendarData(m.ID)} type="button" className="btn btn-outline-danger btn-sm me-2">
                                                                    <i className="bi bi-trash"></i>
                                                                </button>
                                                                <div className="form-check form-switch">
                                                                    <input 
                                                                        className="form-check-input switch" 
                                                                        type="checkbox" 
                                                                        defaultChecked={m.Active == 'N' ? '' : 'checked'} 
                                                                        onChange={(event) => updateActive(m, event.target.checked ? 'Y' : 'N')} 
                                                                    />
                                                                </div>
                                                            </div>
                                                        </li>
                                                    ))}                                   
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                           
                            <div className="accordion-item">
                                <h2 className="accordion-header" id="headingFriday"> 
                                    <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseFriday" aria-expanded="false" aria-controls="collapseFriday" onClick={() => resetData('Friday')}>
                                        Friday
                                    </button>
                                </h2>
                                <div id="collapseFriday" className="accordion-collapse collapse" aria-labelledby="headingFriday" data-bs-parent="#accordionCalendar">
                                    <div className="accordion-body">
                                        <form id='fridayFrom' className={`row mt-4 needs-validation ${fridayValidated ? "was-validated" : ""}`} noValidate onSubmit={(event) => postCalendarData(event, 'Friday')}>
                                            <div className='col-md-5'>
                                                <div className='input-group mb-3 timepicker-ui'>
                                                    <span className='input-group-text fs-16'>From</span>
                                                    <input
                                                        id='txtFromFriday'
                                                        type='text'
                                                        placeholder="Select time"
                                                        className='form-control fs-16 timepicker-ui-input'
                                                        required
                                                    />
                                                    <span className='input-group-text fs-16'><i className="bi bi-clock"></i></span>
                                                    <div className="invalid-feedback">Please select time.</div>
                                                </div>
                                            </div>
                                            <div className='col-md-5'>
                                                <div className='input-group mb-3 timepicker-ui'>
                                                    <span className='input-group-text fs-16'>To</span>
                                                    <input
                                                        id='txtToFriday'
                                                        type='text'
                                                        placeholder="Select time"
                                                        className='form-control fs-16 timepicker-ui-input'
                                                        required
                                                    />
                                                    <span className='input-group-text fs-16'><i className="bi bi-clock"></i></span>
                                                    <div className="invalid-feedback">Please select time.</div>
                                                </div>
                                            </div>
                                            <div className='col-md-2'>
                                                {calendarId != 0 ? (
                                                    <button type="submit" form='fridayFrom' className="btn btn-success btn-header w-100 mb-3">
                                                        Update
                                                    </button>
                                                ) : (
                                                    <button type="submit" form='fridayFrom' className="btn btn-primary btn-header w-100 mb-3">
                                                        <i className="bi bi-plus-lg me-2"></i>Add
                                                    </button>
                                                )}
                                            </div>
                                        </form>

                                        <div className='row mt-3 mb-4'>
                                            <div className='col-12'>
                                                <ul className="list-group">
                                                    {calendar.filter(f => f.Day == 'Friday').length > 0 && calendar.filter(f => f.Day == 'Friday').map((m, i) => (
                                                        <li key={m.ID} className="list-group-item d-flex justify-content-between align-items-center">
                                                            {m.From} - {m.To}
                                                            <div className='d-flex align-items-center'>
                                                                <button onClick={() => updateCalendar(m)} type="button" className="btn btn-outline-primary btn-sm me-2">
                                                                    <i className="bi bi-pencil"></i>
                                                                </button>
                                                                <button onClick={() => deleteCalendarData(m.ID)} type="button" className="btn btn-outline-danger btn-sm me-2">
                                                                    <i className="bi bi-trash"></i>
                                                                </button>
                                                                <div className="form-check form-switch">
                                                                    <input 
                                                                        className="form-check-input switch" 
                                                                        type="checkbox" 
                                                                        defaultChecked={m.Active == 'N' ? '' : 'checked'} 
                                                                        onChange={(event) => updateActive(m, event.target.checked ? 'Y' : 'N')} 
                                                                    />
                                                                </div>
                                                            </div>
                                                        </li>
                                                    ))}                                   
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                           
                            <div className="accordion-item">
                                <h2 className="accordion-header" id="headingSaturday"> 
                                    <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseSaturday" aria-expanded="false" aria-controls="collapseSaturday" onClick={() => resetData('Saturday')}>
                                        Saturday
                                    </button>
                                </h2>
                                <div id="collapseSaturday" className="accordion-collapse collapse" aria-labelledby="headingSaturday" data-bs-parent="#accordionCalendar">
                                    <div className="accordion-body">
                                        <form id='saturdayFrom' className={`row mt-4 needs-validation ${saturdayValidated ? "was-validated" : ""}`} noValidate onSubmit={(event) => postCalendarData(event, 'Saturday')}>
                                            <div className='col-md-5'>
                                                <div className='input-group mb-3 timepicker-ui'>
                                                    <span className='input-group-text fs-16'>From</span>
                                                    <input
                                                        id='txtFromSaturday'
                                                        type='text'
                                                        placeholder="Select time"
                                                        className='form-control fs-16 timepicker-ui-input'
                                                        required
                                                    />
                                                    <span className='input-group-text fs-16'><i className="bi bi-clock"></i></span>
                                                    <div className="invalid-feedback">Please select time.</div>
                                                </div>
                                            </div>
                                            <div className='col-md-5'>
                                                <div className='input-group mb-3 timepicker-ui'>
                                                    <span className='input-group-text fs-16'>To</span>
                                                    <input
                                                        id='txtToSaturday'
                                                        type='text'
                                                        placeholder="Select time"
                                                        className='form-control fs-16 timepicker-ui-input'
                                                        required
                                                    />
                                                    <span className='input-group-text fs-16'><i className="bi bi-clock"></i></span>
                                                    <div className="invalid-feedback">Please select time.</div>
                                                </div>
                                            </div>
                                            <div className='col-md-2'>
                                                {calendarId != 0 ? (
                                                    <button type="submit" form='saturdayFrom' className="btn btn-success btn-header w-100 mb-3">
                                                        Update
                                                    </button>
                                                ) : (
                                                    <button type="submit" form='saturdayFrom' className="btn btn-primary btn-header w-100 mb-3">
                                                        <i className="bi bi-plus-lg me-2"></i>Add
                                                    </button>
                                                )}
                                            </div>
                                        </form>

                                        <div className='row mt-3 mb-4'>
                                            <div className='col-12'>
                                                <ul className="list-group">
                                                    {calendar.filter(f => f.Day == 'Saturday').length > 0 && calendar.filter(f => f.Day == 'Saturday').map((m, i) => (
                                                        <li key={m.ID} className="list-group-item d-flex justify-content-between align-items-center">
                                                            {m.From} - {m.To}
                                                            <div className='d-flex align-items-center'>
                                                                <button onClick={() => updateCalendar(m)} type="button" className="btn btn-outline-primary btn-sm me-2">
                                                                    <i className="bi bi-pencil"></i>
                                                                </button>
                                                                <button onClick={() => deleteCalendarData(m.ID)} type="button" className="btn btn-outline-danger btn-sm me-2">
                                                                    <i className="bi bi-trash"></i>
                                                                </button>
                                                                <div className="form-check form-switch">
                                                                    <input 
                                                                        className="form-check-input switch" 
                                                                        type="checkbox" 
                                                                        defaultChecked={m.Active == 'N' ? '' : 'checked'} 
                                                                        onChange={(event) => updateActive(m, event.target.checked ? 'Y' : 'N')} 
                                                                    />
                                                                </div>
                                                            </div>
                                                        </li>
                                                    ))}                                   
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="accordion-item">
                                <h2 className="accordion-header" id="headingSunday"> 
                                    <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseSunday" aria-expanded="false" aria-controls="collapseSunday" onClick={() => resetData('Sunday')}>
                                        Sunday
                                    </button>
                                </h2>
                                <div id="collapseSunday" className="accordion-collapse collapse" aria-labelledby="headingSunday" data-bs-parent="#accordionCalendar">
                                    <div className="accordion-body">
                                        <form id='sundayFrom' className={`row mt-4 needs-validation ${sundayValidated ? "was-validated" : ""}`} noValidate onSubmit={(event) => postCalendarData(event, 'Sunday')}>
                                            <div className='col-md-5'>
                                                <div className='input-group mb-3 timepicker-ui'>
                                                    <span className='input-group-text fs-16'>From</span>
                                                    <input
                                                        id='txtFromSunday'
                                                        type='text'
                                                        placeholder="Select time"
                                                        className='form-control fs-16 timepicker-ui-input'
                                                        required
                                                    />
                                                    <span className='input-group-text fs-16'><i className="bi bi-clock"></i></span>
                                                    <div className="invalid-feedback">Please select time.</div>
                                                </div>
                                            </div>
                                            <div className='col-md-5'>
                                                <div className='input-group mb-3 timepicker-ui'>
                                                    <span className='input-group-text fs-16'>To</span>
                                                    <input
                                                        id='txtToSunday'
                                                        type='text'
                                                        placeholder="Select time"
                                                        className='form-control fs-16 timepicker-ui-input'
                                                        required
                                                    />
                                                    <span className='input-group-text fs-16'><i className="bi bi-clock"></i></span>
                                                    <div className="invalid-feedback">Please select time.</div>
                                                </div>
                                            </div>
                                            <div className='col-md-2'>
                                                {calendarId != 0 ? (
                                                    <button type="submit" form='sundayFrom' className="btn btn-success btn-header w-100 mb-3">
                                                        Update
                                                    </button>
                                                ) : (
                                                    <button type="submit" form='sundayFrom' className="btn btn-primary btn-header w-100 mb-3">
                                                        <i className="bi bi-plus-lg me-2"></i>Add
                                                    </button>
                                                )}
                                            </div>
                                        </form>

                                        <div className='row mt-3 mb-4'>
                                            <div className='col-12'>
                                                <ul className="list-group">
                                                    {calendar.filter(f => f.Day == 'Sunday').length > 0 && calendar.filter(f => f.Day == 'Sunday').map((m, i) => (
                                                        <li key={m.ID} className="list-group-item d-flex justify-content-between align-items-center">
                                                            {m.From} - {m.To}
                                                            <div className='d-flex align-items-center'>
                                                                <button onClick={() => updateCalendar(m)} type="button" className="btn btn-outline-primary btn-sm me-2">
                                                                    <i className="bi bi-pencil"></i>
                                                                </button>
                                                                <button onClick={() => deleteCalendarData(m.ID)} type="button" className="btn btn-outline-danger btn-sm me-2">
                                                                    <i className="bi bi-trash"></i>
                                                                </button>
                                                                <div className="form-check form-switch">
                                                                    <input 
                                                                        className="form-check-input switch" 
                                                                        type="checkbox" 
                                                                        defaultChecked={m.Active == 'N' ? '' : 'checked'} 
                                                                        onChange={(event) => updateActive(m, event.target.checked ? 'Y' : 'N')} 
                                                                    />
                                                                </div>
                                                            </div>
                                                        </li>
                                                    ))}                                   
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
            
        </>
    )
}

export default Calendar;